import React from 'react';
import ReactDOM from 'react-dom/client';
import { SWRConfig } from 'swr';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <SWRConfig
            value={{
                refreshInterval: 30000,
                revalidateOnFocus: true,
                errorRetryCount: 3,
            }}
        >
            <App />
        </SWRConfig>
    </React.StrictMode>
); 